import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const CNloaihinhptvantai = React.memo(function CNloaihinhptvantai(props) {
  const { loaihinhptvnatai_id } = props;
  const [ten, setTen] = React.useState("");
  const [ma, setMa] = React.useState("");
  const [plvantai, setPlvantai] = React.useState([]);
  const [plvantaivalue, setPlvantaivalue] = React.useState(0);
  const [plphuongtien, setPlphuongtien] = React.useState([]);
  const [plphuongtienvalue, setPlphuongtienvalue] = React.useState(0);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getphanloaivantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmphanloaivantaiall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPlvantai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphanloaiphuongtien = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmplphuongtienall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPlphuongtien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaihinhptvantaitheoid = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getloaihinhptvantaitheoid?id=" +
      loaihinhptvnatai_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setTen(data[0].ten);
          if (data[0].ma) setMa(data[0].ma);
          setPlvantaivalue({
            id: data[0].plvantai_id,
            ten: data[0].plvantai_ten,
          });
          setPlphuongtienvalue({
            id: data[0].plphuongtien_id,
            ten: data[0].plphuongtien_ten,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatloaihinhptvantai = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Donvi/loaihinhptvantai";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: loaihinhptvnatai_id,
          tenloaihinhptvantai: ten,
          maloaihinhptvantai: ma,
          ploaivantaivalue: plvantaivalue,
          plphuongtienvalue: plphuongtienvalue,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (ten.trim() === "") {
      return Error.ER0014;
    }
    if (!plvantaivalue || plvantaivalue === 0) {
      return Error.ER0015;
    }
    if (!plphuongtienvalue || plphuongtienvalue === 0) {
      return Error.ER0016;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getphanloaivantai();
    getphanloaiphuongtien();
    getloaihinhptvantaitheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Tên loại hình phương tiện vận tải"
                variant="outlined"
                value={ten}
                size="small"
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Mã loại phương tiện"
                variant="outlined"
                value={ma}
                size="small"
                onChange={(event) => {
                  setMa(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={plvantai}
                value={plvantaivalue}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setPlvantaivalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setPlvantaivalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Phân loại vận tải"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={plphuongtien}
                value={plphuongtienvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setPlphuongtienvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setPlphuongtienvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Phân loại phương tiện"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatloaihinhptvantai}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

CNloaihinhptvantai.propTypes = {
  loaihinhptvnatai_id: PropTypes.number,
};
export default CNloaihinhptvantai;
